import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
export function getBase64(file) {
  return new _Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = function () {
      return resolve(reader.result);
    };

    reader.onerror = function (error) {
      return reject(error);
    };
  });
}
export function isFileImage(file) {
  var imgRegExp = /(image)+/i;
  return imgRegExp.test(file.type);
}